export var getAvgHourlyPay = function (shiftDuration, totalPay) {
    return totalPay / shiftDuration;
};
